module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/brands-mobile.1fa49ba5.png";